<template>
  <!-- <v-card-title class="px-2 py-1 ma-0 mb-2 header"> -->
  <v-card-title
    :class="
      this.$vuetify.breakpoint.smAndDown
        ? `px-2 py-4 ma-0 header mb-${marginBottom}`
        : `px-5 py-4 ma-0 header mb-${marginBottom}`
    "
  >
    <v-row no-gutters>
      <v-col
        :cols="
          icon || enableExcel
            ? this.$vuetify.breakpoint.smAndDown
              ? 10
              : 11
            : 12
        "
      >
        <b>
          {{ title }}
        </b>
      </v-col>
      <v-col
        :cols="icon ? (this.$vuetify.breakpoint.smAndDown ? 2 : 1) : 0"
        align-self="center"
        style="text-align:right"
      >
        <v-icon v-if="icon" class="icon" @click="iconClicked()">
          {{ icon }}
        </v-icon>
        <vue-excel-xlsx
          v-if="enableExcel"
          :data="excelData"
          :columns="excelColumns"
          :filename="excelFile"
          :sheetname="excelSheet"
        >
          <v-icon class="icon">
            {{ this.excelIcon }}
          </v-icon>
        </vue-excel-xlsx>
      </v-col>
    </v-row>
  </v-card-title>
</template>

<script>
import { dictionary } from "../../helpers";

export default {
  props: {
    title: String,
    icon: String,
    enableExcel: Boolean,
    excelData: Array,
    excelColumns: Array,
    excelFile: String,
    excelSheet: String,
    marginBottom: {
      default: 2
    }
  },
  methods: {
    iconClicked() {
      this.$emit("iconClicked");
    }
  },
  data() {
    return {
      excelIcon: dictionary.mdi.excel
    };
  }
};
</script>

<style>
@import url("../../assets/styles/colors.css");
</style>

<style>
.header {
  /* background: linear-gradient(
    360deg,
    var(--GLS-blue-100) 0%,
    var(--gradient-blue) 143.9%
  ); */
  background-color: var(--GLS-blue-100);
  color: var(--GLS-white);
}
.icon {
  color: var(--GLS-white) !important;
  cursor: pointer;
}
</style>
